import styled from 'styled-components';
import { rem } from 'polished';
import TitleWidget from '../../../core/TitleWidget';
import BoxInside from '../../../core/BoxInside';
import Icon from '../../../core/Icon';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import TwoLevelBreadcrumb from '../../../core/TwoLevelBreadcrumb';

const StyledBoxInside = styled(BoxInside)`
  padding-bottom: ${rem('80px')};
`;

const StyledTitleWidget = styled(TitleWidget)`
  color: #fff;
  line-height: ${rem('30px')};
  margin-bottom: ${rem('25px')};
  margin-left: ${rem('18px')};
  padding-left: ${rem('15px')};

  & > svg {
    left: ${rem('-25px')};

    bottom: 0;
    ${mediaqueries.greaterThan('tabletLandscape')`
      left: ${rem('-28px')};
      width: ${rem('38px')};
      height: ${rem('45px')};
    `};
  }
`;

const StyledWrapperStationDirectory = styled.div`
  margin-bottom: ${rem('26px')};
`;

const StyledWrapperPaginator = styled.div`
  width: ${rem('50px')};
  margin: 0 auto ${rem('50px')};
`;

const StyledTableWrapper = styled.div`
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: table;
    width: 100%;
  `};
`;

const StyledHeaderDirectory = styled.div`
  display: none;
  ${mediaqueries.greaterThan('tabletLandscape')`
     display: table-header-group;
  `};
`;

const StyledHeaderItem = styled.div`
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.dark};
  display: table-cell;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  overflow: hidden;
  padding: ${rem('0px')} ${rem('10px')};
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledRentalDirectory = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  display: block;
  padding: ${rem('17px')} ${rem('25px')};
  max-height: ${rem('74px')};
  overflow: hidden;
  position: relative;
  &:nth-child(1) {
    border-top: ${rem('2px')} solid ${props => props.theme.colors.grayDark};
  }

  ${props =>
    props.active &&
    `
    max-height: none;
  `};

  ${mediaqueries.greaterThan('tabletLandscape')`
    background-color: ${props => props.theme.colors.grayMoreLight};
    border-bottom-color: ${props => props.theme.colors.grayLighter};
    display: table-row-group;
    max-width: inherit;
    padding: ${rem('11px')};
    max-height: none;
    overflow: auto;
  `};
`;

const IconButton = styled(Icon)`
  fill: ${props =>
    props.active ? props.theme.colors.primary : props.theme.colors.dark};
  left: ${rem('7px')};
  margin-right: 1rem;
  position: absolute;
  top: ${rem('23px')};
  transform: rotate(90deg);
  transition: none;
  width: ${rem('15px')};
  height: ${rem('12px')};

  ${props =>
    props.active &&
    `
    transform: rotate(-90deg);
  `};
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: none;
  `};
`;

const StyledNamesWraper = styled.div`
  margin-right: ${rem('20px')};
  width: 77%;

  ${mediaqueries.greaterThan('tabletLandscape')`
    display: table;
    width: 100%;
  `};
`;

const StyledStationName = styled.div`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  max-width: ${rem('120px')};
  ${mediaqueries.greaterThan('tabletLandscape')`
    border-bottom: ${rem('1px')} solid ${props =>
    props.theme.colors.grayLighter};
    display: table-cell;
    font-family: ${props => props.theme.fonts.book};
    margin-right: ${rem('20px')};
    overflow: hidden;
    padding: ${rem('15px')} ${rem('10px')};
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('120px')};
  `};
`;

const StyledCellOrder = styled(StyledStationName)`
  max-width: ${rem('186px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('186px')};
  `};
`;

const StyledStationTableCell = styled.div`
  display: block;
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  ${mediaqueries.greaterThan('tabletLandscape')`
    border-bottom: 1px solid ${props => props.theme.colors.grayLighter};
    display: table-cell;
    margin-right: ${rem('20px')};
    padding: ${rem('10px')} ${rem('10px')};
    vertical-align: middle;
  `};
`;

const StyledCellPos = styled(StyledStationTableCell)`
  max-width: ${rem('45px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('45px')};
  `};
`;

const StyledCellText = styled(StyledStationTableCell)`
  max-width: ${rem('425px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('425px')};
  `};
`;

const StyledCellStation = styled(StyledStationTableCell)`
  max-width: ${rem('272px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('272px')};
  `};
`;

const StyledCellPrice = styled(StyledStationTableCell)`
  max-width: ${rem('75px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('130px')};
  `};
`;

const StyledCellDate = styled(StyledStationTableCell)`
  max-width: 98%;
  ${mediaqueries.greaterThan('desktop')`
     max-width: ${rem('130px')};
     width: ${rem('130px')};
  `};
`;

const StyledIcon = styled(Icon)`
  margin-top: ${rem('15px')};
  &:first-child {
    margin-right: ${rem('15px')};
    margin-top: ${rem('0px')};
  }
`;

const StyledSearchFormControl = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${rem('35px')};

  ${mediaqueries.greaterThan('mobile')`
      width: auto;
      flex-wrap: nowrap;
    `}

  .wrapper-control {
    ${mediaqueries.greaterThan('mobile')`
      &:nth-child(2n + 1){
        margin-left: ${rem('15px')};
      }
      &:first-child{
        margin-left: 0;
      }
    `}
  }

  .wrapper-btn-send {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    height: ${rem('59px')};

    ${mediaqueries.greaterThan('mobile')`
      width: auto;      
      margin-left: ${rem('15px')};
    `}
  }
  .btn-send {
    height: ${rem('40px')};
    align-self: flex-end;
    ${mediaqueries.greaterThan('desktop')`
      margin-left: ${rem('5px')};
    `}
  }
  .drop-station {
    width: 100%;
    ${mediaqueries.greaterThan('desktop')`
      width: ${rem('164px')};
    `}
  }
`;

const StyledTwoLevelBreadcrumb = styled(TwoLevelBreadcrumb)`
  margin: 0 ${rem('15px')} ${rem('20px')};
  ${mediaqueries.greaterThan('desktop')`
    margin: 0 0 ${rem('55px')};
  `}
`;

export {
  StyledBoxInside,
  StyledTitleWidget,
  StyledWrapperStationDirectory,
  StyledWrapperPaginator,
  StyledTableWrapper,
  StyledHeaderDirectory,
  StyledHeaderItem,
  StyledRentalDirectory,
  StyledNamesWraper,
  StyledStationName,
  StyledCellOrder,
  StyledCellPos,
  StyledCellText,
  StyledCellStation,
  StyledCellPrice,
  StyledCellDate,
  StyledIcon,
  IconButton,
  StyledSearchFormControl,
  StyledTwoLevelBreadcrumb
};
